const $ = jQuery.noConflict();
import Global from '../shared/global';
import cf7Helpers from '../shared/cf7Helpers';

'use strict';
const SubscribeWidget = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domWidget: $('.js-subscribe-widget'),
	$domTrigger: $('.js-subscribe-widget-trigger'),
	$domPopup: $('.js-subscribe-widget-popup'),
	$domClose: $('.js-subscribe-widget-close'),
	classActive: 'is-active',

	/** @description Initialize */
	init: function() {
		if (!this.$domWidget.length) {
			return;
		}

		this.bindEvents();
		cf7Helpers.afterFormSubmit();
		cf7Helpers.preventNumTelInputsTypeLetters();
	},

	/** @description Bind Events */
	bindEvents: function() {
		this.$domTrigger.on('click', this.togglePopup.bind(this));
		this.$domClose.on('click', this.closePopup.bind(this));
		Global.escKey(this.closePopup.bind(this));
		Global.clickOutsideContainer(Global.$domBody, this.$domPopup, this.$domTrigger, this.closePopup.bind(this));
	},

	togglePopup: function() {
		this.$domWidget.toggleClass(this.classActive);
	},

	closePopup: function() {
		this.$domWidget.removeClass(this.classActive);
	}
};

export default SubscribeWidget;
